<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12 pt-3 pb-3 pl-4">
        <h3><i class="fas fa-calendar-alt"></i> Meus agendamentos</h3>
      </div>
    </div>
    <MinhasVisitasList ref="minhasVisitasList" />
  </div>
</template>
<script>
import Tools from '@/components/tools/Tools.js'
import MinhasVisitasList from './components/list/minhasVisitasList.vue'

export default {
  name: 'minhasVisitas',
  data () {
    return {
      showAdd: false
    }
  },
  components: {
    MinhasVisitasList
  },
  mounted () {
  },
  methods: {
    onLoad () {},
    onBack () {
      this.showAdd = false
    }
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/visitas/minhasVisitas/minhasVisitas.vue